export default "__VITE_ASSET__$gazP1uq__"